<div
  class="quote-pdf-page app-aul-102-24"
  *ngFor="
    let address of (quoteDetails?.addressInfo ?? []);
    let i = index;
    let last = last
  "
>
  <ng-container *ngIf="i === 0">
    <app-policy-header></app-policy-header>
    <p style="font-size: 22px; text-align: center;">
      <b>QUOTE</b>
    </p>
    <p style="font-size: 22px; text-align: center;">
      <b>COMMERCIAL PROPERTY QUOTE LIMITS</b>
    </p>
    <p style="font-size: 19px;">
      <b>
        This Commercial Property Quotation Limits is attached to and forms part of
        the Quote numbered {{ this.quoteDetails?.quoteNo }} - 0{{ quoteDetails?.versionNo }}
      </b>
    </p>
    <p style="font-size: 14px;">
      Coinsurance condition percentage to apply to all Coverage Sections 90% unless otherwise described in the Policy.
    </p>
    <br />
    <br />
  </ng-container>

  <table style="width: 100% !important; font-size:14px;">
    <tbody>
      <tr>
        <td style="width:100%; font-size: 19px;">
          <b
            >Covered Premises Address {{ i + 1 }} of
            {{ this.quoteDetails?.addressInfo?.length }}</b
          >
        </td>
      </tr>
      <tr>
        <td style="width: 100% !important;">
          <b
            >{{ address?.streetNum }}, {{ address?.streetName }},
            {{ address?.unitNum ? address?.unitNum + "," : "" }}
            {{ address?.city }}, {{ address?.county }}, {{ address?.state }},
            {{ address?.zipcode }}</b
          >
        </td>
      </tr>
    </tbody>
  </table>
  <table style="width: 100% !important; font-size:14px;">
    <tbody *ngFor="let building of address?.buildings; let j = index">
      <tr>
        <td style="width: 50% !important;"><b>Coverage Sections</b></td>
        <td style="width: 50% !important;"><b>Limit of Insurance</b></td>
      </tr>
      <tr>
        <td style="width: 50% !important;">Building {{ j + 1 }}</td>
        <td style="width: 50% !important;">
          $ {{ building?.buildingLimit | currency : "USD" : "" : "1.2-2" }}
        </td>
      </tr>
      <tr>
        <td style="width: 50% !important;">Business Personal Property</td>
        <td style="width: 50% !important;">
          $
          {{
            building?.businessPropertyLimit | currency : "USD" : "" : "1.2-2"
          }}
        </td>
      </tr>
      <tr>
        <td style="width: 50% !important;">Ordinance or Law</td>
        <td style="width: 50% !important;">
          {{ building?.oandLFlag === 1 ? "Included" : "Excluded" }}
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <table style="width: 100% !important; font-size:14px;">
    <tbody>
      <tr>
        <td style="width: 50% !important;"><b>Business Income and Extra Expense</b></td>
        <td style="width: 50% !important;">
          $
          {{ address?.businessIncomeLimit | currency : "USD" : "" : "1.2-2" }}
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <table style="width: 100% !important; font-size:14px;">
    <tbody
      *ngFor="
        let addnlStructure of address?.additionalStructures;
        let k = index
      "
    >
      <tr>
        <td style="width: 50% !important;"><b>Additional Property Coverage</b></td>
        <td style="width: 50% !important;"></td>
      </tr>
      <tr>
        <td style="width: 50% !important;">{{ addnlStructure?.otherStructureOtherDesc }}</td>
        <td style="width: 50% !important;">
          $
          {{
            (addnlStructure?.otherStructureFactorAmount ?? 0)
              | currency : "USD" : "" : "1.2-2"
          }}
        </td>
      </tr>
    </tbody>
  </table>

  <ng-container *ngIf="last">
    <table style="width: 100% !important; font-size:14px;">
      <tbody>
        <tr>
          <td style="width: 50% !important;"><b>Total limit of Insurance</b></td>
          <td style="width: 50% !important;">
            $
            {{
              this.quoteDetails?.totalInsuredValue
                | currency : "USD" : "" : "1.2-2"
            }}<b> All Covered Premises</b>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table style="width: 100% !important; font-size:14px;">
      <tbody>
        <tr>
          <td style="width: 50% !important;"><b>Coverage and Deductibles</b></td>
          <td style="width: 50% !important;"></td>
        </tr>
        <tr>
          <td style="width: 50% !important;">
            Covered Causes of Loss and Basis of Valuation
            <p style="font-style: italic; font-size: 9px">
              *Unless as notified in the Policy Forms and Endorsements
            </p>
          </td>
          <td style="width: 50% !important;">{{ this.quoteDetails?.causeOfLossDesc }}</td>
        </tr>
        <tr>
          <td style="width: 50% !important;">All Other Cause of Loss Deductible</td>
          <td style="width: 50% !important;">{{ this.quoteDetails?.aopDeductibleDescription }}</td>
        </tr>
      </tbody>
    </table>
    <table style="width: 100% !important; font-size:14px;">
      <tbody>
        <tr>
          <td style="width: 50% !important;">Wind and Hail</td>
          <td style="width: 50% !important;">
            {{
              this.quoteDetails?.windDeductibleFlag === 0
                ? "Included"
                : "Excluded"
            }}
          </td>
        </tr>
        <tr>
          <td style="width: 50% !important;">Wind and Hail Deductible</td>
          <td style="width: 50% !important;">{{ this.quoteDetails?.windDeductibleDescription }}</td>
        </tr>
        <tr>
          <td style="width: 50% !important;">Property Enhancement</td>
          <td style="width: 50% !important;">
            {{
              this.quoteDetails?.propertyExtCoverageDescription === ""
                ? "No enhancement selected"
                : this.quoteDetails?.propertyExtCoverageDescription
            }}
          </td>
        </tr>
        <tr>
          <td style="width: 50% !important;">Water Damage</td>
          <td style="width: 50% !important;">{{ this.quoteDetails?.waterDamageDescription }}</td>
        </tr>
        <tr>
          <td style="width: 50% !important;">Theft Coverage</td>
          <td style="width: 50% !important;">{{ this.quoteDetails?.vandalismDescription }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
